export default "__VITE_ASSET__DFnBXDmB__"